export const uniqueArray = <T extends Array<any>>(arr: T) =>
	[...new Set(arr)] as T;

export default uniqueArray;
